import "./HeroImageStyles.css";
import image1 from "../pictures/image1.jpg"
import { Link } from 'react-router-dom';

import React from 'react'

const HeroImage = () => {
  return (
    <div className="hero">
      <div className="mask">
        <img className="intro-img" src  ={image1} alt="introImg" />
      </div>
      <div className="content">
        <h1>SIMUN BISWAS</h1>
        <p>Frontend Developer<br />I'm a Freelancer</p>

        <div>
          <Link to="/project" className="btn">Projects</Link>
          <Link to="/contact" className="btn btn-light">Contact</Link>
        </div>
      </div>      
    </div>
  )
}

export default HeroImage
